<template>
  <section>
    <h3>
      Shelters
    </h3>
    <router-link :to="{name: 'ShelterStatus'}">
      <b-button>
        <b-icon
          icon="chevron-double-left">
        </b-icon>
        Shelter Status
      </b-button>
    </router-link>
    <router-link :to="{name: 'Shelter:Create'}">
      <b-button>
        <b-icon
          icon="plus">
        </b-icon>
        Create
      </b-button>
    </router-link>
    <b-table
        :data="formattedShelters"
        :columns="columns">
    </b-table>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ShelterList',
  data() {
    return {
      columns: [
        {
          field: 'code',
          label: 'Code',
          searchable: true,
        },
        {
          field: 'name',
          label: 'Name',
          searchable: true,
        },
        {
          field: 'status',
          label: 'Status',
          searchable: true,
        },
        {
          field: 'location',
          label: 'Location',
          searchable: true,
        }
      ]
    }
  },
  mounted () {
    this.fetch()
  },
  computed: {
    ...mapGetters('Shelter', ['shelters']),
    formattedShelters () {
      return this.shelters.map(i => {
        const locs = i.location.split(',')
        return {
          ...i,
          location: locs[0] + ' , ' + locs[1]
        }
      })
    }
  },
  methods: {
    ...mapActions('Shelter', ['fetch'])
  }
}
</script>
